module.exports = __webpack_public_path__ + "img/ca_zampa_animale_1.61558e15.jpg";